import { render, staticRenderFns } from "./DiscussDetail.vue?vue&type=template&id=99de00bc&scoped=true&"
import script from "./DiscussDetail.vue?vue&type=script&lang=js&"
export * from "./DiscussDetail.vue?vue&type=script&lang=js&"
import style0 from "./DiscussDetail.vue?vue&type=style&index=0&id=99de00bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99de00bc",
  null
  
)

export default component.exports